import { getAmplitudeInstance } from '../amplitudeHelpers';

type logCellCoverageCalloutTappedParams = {
  list_id?: string;
  park_id?: number;
  trail_id?: number;
};

/**
 * Cell coverage callout was tapped by the user
 * @param params - Attributes to log with the amplitude event
 * @param params.list_id - Id of the list being viewed.
 * @param params.park_id - Park Id being viewed
 * @param params.trail_id - Trail Id being viewed
 */
const logCellCoverageCalloutTapped = ({ list_id, park_id, trail_id }: logCellCoverageCalloutTappedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('cell coverage callout tapped', { 'list id': list_id, 'park id': park_id, 'trail id': trail_id }, callback);
};

export default logCellCoverageCalloutTapped;
